import styled from "styled-components";
import Hero from "src/components/Hero/Hero";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import EventFinished from "src/components/EventFinished";
import SubTitleSection from "src/components/SubTitleSection/SubTitleSection";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import DynamicGoogleFormSubmitter from "src/components/Form/DynamicGoogleFormSubmitter";

const RcgCruiseJuly2026Rsvp = () => {
  const { t, i18n } = useTranslation();

  return (
    <Div>
      <Hero
        bgImage="promotions/gaming-machines/rcg-cruise-july-2026/rc-hero-image-2400x1150px.jpg"
        image={`promotions/gaming-machines/rcg-cruise-july-2026/rc-logo-2400x900px-${i18n.language}.png`}
        imageAlt={t("rcgCruiseJuly2026Rsvp.hero.logoAlt")}
        title={t("rcgCruiseJuly2026Rsvp.hero.title")}
        description={t("rcgCruiseJuly2026Rsvp.hero.subtitle")}
        descriptionBgColor="#b8a47d"
        className="rcg-hero"
        fluidImage
      />
      <EventFinished
        scheduleKeyName="rcgCruiseJuly2026Rsvp"
        eventType="promotion"
      />
      <MainContentDiv>
        <SectionsWrapper>
          <BlueSection>
            <div className="sections-inner">
              <SubTitleSection
                subTitle={t("rcgCruiseJuly2026Rsvp.content.title")}
                text={t("rcgCruiseJuly2026Rsvp.content.text")}
                borderColor="#738690"
                dark={false}
                as="h2"
                className="blue-title"
              />
            </div>
          </BlueSection>
          <DetailsSection>
            <div className="sections-inner">
              <div className="content-wrapper">
                <div className="details-column">
                  <SubTitleSection
                    subTitle={t("rcgCruiseJuly2026Rsvp.eventDetails.title")}
                    borderColor="#738690"
                    dark={false}
                    as="h2"
                    className="details-title"
                  />
                  <div className="details-grid">
                    <div>
                      <span className="label">
                        {t("rcgCruiseJuly2026Rsvp.eventDetails.whereLabel")}
                      </span>
                      <p>{t("rcgCruiseJuly2026Rsvp.eventDetails.whereText")}</p>
                    </div>
                    <div>
                      <span className="label">
                        {t("rcgCruiseJuly2026Rsvp.eventDetails.timeLabel")}
                      </span>
                      <p>{t("rcgCruiseJuly2026Rsvp.eventDetails.timeText")}</p>
                    </div>
                  </div>
                </div>
                <div className="form-column">
                  <SubTitleSection
                    subTitle={t("rcgCruiseJuly2026Rsvp.form.heading")}
                    borderColor="#738690"
                    dark={false}
                    as="h2"
                    className="details-title"
                  />
                  <DynamicGoogleFormSubmitter
                    formId="AKfycbxI15hUXwYRhLV9DPpuBVXjS3m8uj_sDC2zdq3tRvOOwQ3MkPmG4_-Fr4e4azu_XNHF_Q"
                    sheetName="RSVP"
                    formTextKey="rcgCruiseJuly2026Rsvp"
                    titles={false}
                    formFields={[
                      {
                        id: "FirstName",
                        label: "firstName",
                        type: "text",
                        required: true
                      },
                      {
                        id: "LastName",
                        label: "lastName",
                        type: "text",
                        required: true
                      },
                      {
                        id: "PlayerID",
                        label: "pgPlayerId",
                        type: "text",
                        required: true,
                        placeholder: "pgPlayerIdPlaceholder"
                      },
                      {
                        id: "Dates",
                        label: "date",
                        type: "select",
                        required: true,
                        options: t("rcgCruiseJuly2026Rsvp.form.dateOptions", { returnObjects: true })
                      }
                    ]}
                  />
                </div>
              </div>
            </div>
          </DetailsSection>
          <ImageWrapper>
            <ResponsiveImage
              src="promotions/gaming-machines/rcg-cruise-july-2026/rc-cruise-photos.png"
              alt={t("rcgCruiseJuly2026Rsvp.eventDetails.title")}
            />
          </ImageWrapper>
        </SectionsWrapper>
        <container-div>
          <ReactMarkdown className="rsvp-note">
            {t("rcgCruiseJuly2026Rsvp.content.alternateRsvp")}
          </ReactMarkdown>
        </container-div>
      </MainContentDiv>
    </Div>
  );
};

const Div = styled.div`
  width: 100%;
  height: auto;

  .hero_container {
    margin-bottom: 120px;
    background-position: bottom;
    overflow: visible;
  }

  .rcg-hero {
    .hero_image_container {
      padding: 20px 20px 40px;
      min-height: 900px;
      justify-content: flex-start;
    }

    .hero_image {
      max-width: 820px;
      margin-top: 140px;
      width: 100%;
    }

    .hero_text_container {
      position: relative;
      bottom: -120px;
      background-color: #b8a47d;
      backdrop-filter: none;
      padding: 40px 20px;
      z-index: 1;
    }

    .hero_text_container h1 {
      margin-bottom: 20px;
      color: #fff;
      font-size: 1.8rem;
      font-weight: 700;
    }

    .hero_text_container p {
      font-size: 1.1rem;
      margin: 0;
      color: #fff;
      line-height: 1.6;
    }
  }

  @media (max-width: 991px) {
    .hero_container {
      margin-bottom: 180px;
    }

    .rcg-hero {
      .hero_image_container {
        min-height: 400px;
        padding: 20px;
      }

      .hero_text_container {
        bottom: -180px;
      }
    }
  }
`;

const MainContentDiv = styled.div`
  background-color: var(--white);
  width: 100%;

  .rsvp-note {
    margin: 2rem auto;
    padding: 0 1.5rem;
    text-align: center;
    font-size: 1.05rem;
    color: #5b5b5b;
  }

  .rsvp-note a,
  .rsvp-note strong {
    color: #0066a1;
    text-decoration: none;
  }

  .rsvp-note a:hover,
  .rsvp-note a:focus {
    text-decoration: underline;
  }

  @media (min-width: 1896px) {
    .rsvp-note {
      margin-top: 2rem;
    }
  }
`;

const SectionsWrapper = styled.div`
  position: relative;
  width: 100%;

  .subtitle-section {
    h2::before {
      width: fit-content;
    }
  }

  @media (max-width: 992px) {
    position: static;
  }
`;

const BlueSection = styled.section`
  background-color: #0066a1;
  width: 100%;
  padding: 3rem 0;
  position: relative;

  .sections-inner {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 2rem;
  }

  .blue-title {
    max-width: 50%;

    h2 {
      color: #fff;
      font-size: 2rem;
      font-weight: 700;
    }

    p {
      font-size: 1.1rem;
      margin-top: 1rem;
      color: #fff;
      line-height: 1.6;
    }

    strong {
      color: #fff;
      font-weight: 700;
    }
  }

  @media (max-width: 992px) {
    padding: 2.5rem 0;

    .sections-inner {
      padding: 0 1.5rem;
    }

    .blue-title {
      max-width: 100%;
    }
  }
`;

const DetailsSection = styled.section`
  background-color: #fff;
  width: 100%;
  padding: 3rem 0;
  position: relative;

  .sections-inner {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 2rem;
    position: relative;
  }

  .content-wrapper {
    display: grid;
    grid-template-columns: 1fr 2fr;
    max-width: 55%;
  }

  .form-column {
    display: flex;
    flex-direction: column;
    .form-container {
      background-color: rgb(0, 102, 161);
      border: none;
      button {
        background: rgb(41, 143, 202);
        &:hover {
          background: var(--white);
        }
      }
    }
  }

  .details-column {
    display: flex;
    flex-direction: column;
  }

  .details-title {
    padding: 0 0 1.5rem;

    h2 {
      font-weight: 800;
      font-size: 1.6rem;
      color: #000;
    }
  }

  .details-grid {
    display: grid;
    gap: 1.5rem;
    grid-template-columns: 1fr;
  }

  .details-grid > div {
    display: flex;
    flex-direction: column;
  }

  .details-grid p {
    margin: 0.35rem 0 0;
    white-space: pre-line;
    font-size: 1rem;
    color: #5b5b5b;
    line-height: 1.5;
  }

  .label {
    font-weight: 700;
    text-transform: uppercase;
    font-size: 0.85rem;
    letter-spacing: 0.08em;
    color: #0066a1;
    display: block;
  }

  @media (max-width: 992px) {
    padding: 2.5rem 0;

    .sections-inner {
      padding: 0 1.5rem;
    }

    .content-wrapper {
      grid-template-columns: 1fr;
      gap: 2rem;
      max-width: 100%;
    }
  }
`;

const ImageWrapper = styled.div`
  position: absolute;
  right: calc((100vw - 1400px) / 2 + 2rem);
  top: 50%;
  transform: translateY(-50%);
  width: 45%;
  max-width: 500px;
  z-index: 1;

  img {
    width: 100%;
    height: auto;
  }

  @media (max-width: 1440px) {
    right: 2rem;
    width: 42%;
  }

  @media (max-width: 1200px) {
    width: 40%;
    max-width: 400px;
  }

  @media (max-width: 992px) {
    position: static;
    transform: none;
    width: 100%;
    max-width: 100%;
    margin: 2rem auto;
    padding: 0 1.5rem;
  }
`;

export default RcgCruiseJuly2026Rsvp;
